import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    searchTerm: '',
    period: null,
    itemCount: undefined,
    unblockToPickingTaskDialog: {
        open: false,
        data: undefined,
    },
    unblockAndPlaceDialog: {
        open: false,
        data: undefined,
    },
};
const slice = createSlice({
    name: 'stock/blocked',
    initialState,
    reducers: {
        setSearchTerm: (state, action) => {
            state.searchTerm = action.payload;
        },
        setPeriod: (state, action) => {
            state.period = action.payload;
        },
        setItemCount: (state, action) => {
            state.itemCount = action.payload;
        },
        openUnblockToPickingTaskDialog: (state, action) => {
            state.unblockToPickingTaskDialog = {
                open: true,
                data: action.payload,
            };
        },
        closeUnblockToPickingTaskDialog: (state) => {
            state.unblockToPickingTaskDialog.open = initialState.unblockToPickingTaskDialog.open;
            // Should not be used to prevent data removing and dialog size flickering before dialog close transition is over.
            // state.unblockToPickingTaskDialog = initialState.unblockToPickingTaskDialog;
        },
        openUnblockAndPlaceDialog: (state, action) => {
            const { id: itemId, cellId, cellName, stockId, stockName, quantity: totalQuantity, name } = action.payload;
            state.unblockAndPlaceDialog = {
                open: true,
                data: {
                    itemId,
                    cellId,
                    cellName,
                    stockId,
                    stockName,
                    totalQuantity,
                    detailName: name,
                },
            };
        },
        closeUnblockAndPlaceDialog: (state) => {
            state.unblockAndPlaceDialog = initialState.unblockAndPlaceDialog;
        },
    },
});
export const { actions: stockBlockedActions, reducer: stockBlockedStateReducer } = slice;
